// import React, { useState } from "react";

// export const OutDoorEntries = () => {
//   const [form, setForm] = useState({
//     fromDate: "",
//     toDate: "",
//     fromTime: "",
//     toTime: "",
//     location: "",
//     employee: "",
//     purpose: "",
//   });
//   const [list, setList] = useState([]);

//   const employees = [
//     { id: 1, name: "Arun" },
//     { id: 2, name: "Priya" },
//     { id: 3, name: "Vijay" },
//   ]; // your employee data

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSave = () => {
//     if (
//       !form.fromDate ||
//       !form.toDate ||
//       !form.fromTime ||
//       !form.toTime ||
//       !form.employee
//     ) {
//       alert("Please fill all required fields");
//       return;
//     }

//     setList([...list, form]);

//     setForm({
//       fromDate: "",
//       toDate: "",
//       fromTime: "",
//       toTime: "",
//       location: "",
//       employee: "",
//       purpose: "",
//     });
//   };
//   return (
//     <div className="container mt-4">
//       <h3 className="mb-4">Outdoor Entry</h3>

//       <div className="card p-3">
//         <div className="row g-3">
//           {/* Date */}
//           <div className="col-md-3">
//             <label className="form-label">From Date</label>
//             <input
//               type="date"
//               className="form-control"
//               name="fromDate"
//               value={form.fromDate}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="col-md-3">
//             <label className="form-label">To Date</label>
//             <input
//               type="date"
//               className="form-control"
//               name="toDate"
//               value={form.toDate}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="col-md-3">
//             <label className="form-label">From Time</label>
//             <input
//               type="time"
//               className="form-control"
//               name="fromTime"
//               value={form.fromTime}
//               onChange={handleChange}
//             />
//           </div>

//           {/* To Time */}
//           <div className="col-md-3">
//             <label className="form-label">To Time</label>
//             <input
//               type="time"
//               className="form-control"
//               name="toTime"
//               value={form.toTime}
//               onChange={handleChange}
//             />
//           </div>

//           {/* Location */}
//           <div className="col-md-4">
//             <label className="form-label">Location</label>
//             <input
//               type="text"
//               className="form-control"
//               name="location"
//               placeholder="Enter location"
//               value={form.location}
//               onChange={handleChange}
//             />
//           </div>
//           <div className="col-md-4">
//             <label className="form-label">Purpose</label>
//             <input
//               type="text"
//               className="form-control"
//               name="purpose"
//               placeholder="Purpose"
//               value={form.purpose}
//               onChange={handleChange}
//             />
//           </div>

//           {/* Employee */}
//           <div className="col-md-4">
//             <label className="form-label">Employee</label>
//             <select
//               className="form-select"
//               name="employee"
//               value={form.employee}
//               onChange={handleChange}
//             >
//               <option value="">Select Employee</option>
//               {employees.map((emp) => (
//                 <option key={emp.id} value={emp.name}>
//                   {emp.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="col-12 text-end">
//             <button
//               type="button"
//               className="btn add-emp-btn d-flex align-items-center gap-2 py-2 px-3 mt-4"
//               onClick={handleSave}
//             >
//               Save
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* TABLE */}
//       <div className="mt-4">
//         <h4 className="mb-3">Missed Punch List</h4>
//         <div className="table-responsive settings-table mt-3">
//           <table className="table table-hover m-0">
//             <thead>
//               <tr className="align-middle border-top">
//                 <th>S.No</th>
//                 <th>From Date</th>
//                 <th>To Date</th>
//                 <th>From Time</th>
//                 <th>To Time</th>
//                 <th>Location</th>
//                 <th>Purpose</th>
//                 <th>Employee</th>
//               </tr>
//             </thead>
//             <tbody>
//               {list.length === 0 ? (
//                 <tr>
//                   <td colSpan="5" className="text-center">
//                     No entries
//                   </td>
//                 </tr>
//               ) : (
//                 list.map((item, index) => (
//                   <tr key={index}>
//                     <td>{index + 1}</td>
//                     <td>{item.fromDate}</td>
//                     <td>{item.toDate}</td>
//                     <td>{item.fromTime}</td>
//                     <td>{item.toTime}</td>
//                     <td>{item.location}</td>
//                     <td>{item.purpose}</td>
//                     <td>{item.employee}</td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//         {/* <table className="table table-bordered table-striped">
//           <thead className="table-dark">
//             <tr>
//               <th>S.No</th>
//               <th>Date</th>
//               <th>Direction</th>
//               <th>Employee</th>
//               <th>Remarks</th>
//             </tr>
//           </thead>
//           <tbody>
//             {list.length === 0 ? (
//               <tr>
//                 <td colSpan="5" className="text-center">
//                   No entries
//                 </td>
//               </tr>
//             ) : (
//               list.map((item, index) => (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                   <td>{item.date}</td>
//                   <td>{item.direction}</td>
//                   <td>{item.employee}</td>
//                   <td>{item.remarks}</td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table> */}
//       </div>
//     </div>
//   );
// };

import React, { useEffect, useState } from "react";
import api from "../../api/axios";

export const OutDoorEntries = () => {
  const [form, setForm] = useState({
    from_date: "",
    to_date: "",
    from_time: "",
    to_time: "",
    location: "",
    purpose: "",
    employee_id: "",
  });

  const [employees, setEmployees] = useState([]);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  // ============= API FUNCTIONS ==================
  const loadEmployees = async () => {
    const res = await api.get("/hrms/employees");
    setEmployees(res.data.data || []);
  };

  const loadOutdoorEntries = async () => {
    setLoading(true);
    const res = await api.get("/hrms/outdoor"); // <--- API endpoint
    setList(res.data.data || []);
    setLoading(false);
  };

  const saveOutdoorEntry = async () => {
    if (
      !form.from_date ||
      !form.to_date ||
      !form.from_time ||
      !form.to_time ||
      !form.employee_id
    ) {
      alert("Please fill required fields");
      return;
    }

    setSaving(true);
    try {
      await api.post("/hrms/outdoor", form);
      await loadOutdoorEntries();

      setForm({
        from_date: "",
        to_date: "",
        from_time: "",
        to_time: "",
        location: "",
        purpose: "",
        employee_id: "",
      });

      alert("Outdoor Entry Saved");
    } catch (err) {
      console.error(err);
      alert("Failed to save");
    }
    setSaving(false);
  };

  // ============= INIT LOAD ==================
  useEffect(() => {
    loadEmployees();
    loadOutdoorEntries();
  }, []);

  // ============= HELPERS ==================
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const timeFormat = (t) => {
    if (!t) return "";
    return new Date(`1970-01-01T${t}`).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Outdoor Entry</h3>

      <div className="card p-3">
        <div className="row g-3">
          {/* Date */}
          <div className="col-md-3">
            <label className="form-label">From Date</label>
            <input
              type="date"
              className="form-control"
              name="from_date"
              value={form.from_date}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-3">
            <label className="form-label">To Date</label>
            <input
              type="date"
              className="form-control"
              name="to_date"
              value={form.to_date}
              onChange={handleChange}
            />
          </div>

          {/* Time */}
          <div className="col-md-3">
            <label className="form-label">From Time</label>
            <input
              type="time"
              className="form-control"
              name="from_time"
              value={form.from_time}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-3">
            <label className="form-label">To Time</label>
            <input
              type="time"
              className="form-control"
              name="to_time"
              value={form.to_time}
              onChange={handleChange}
            />
          </div>

          {/* Location */}
          <div className="col-md-4">
            <label className="form-label">Location</label>
            <input
              type="text"
              className="form-control"
              name="location"
              placeholder="Enter location"
              value={form.location}
              onChange={handleChange}
            />
          </div>

          {/* Purpose */}
          <div className="col-md-4">
            <label className="form-label">Purpose</label>
            <input
              type="text"
              className="form-control"
              name="purpose"
              placeholder="Purpose"
              value={form.purpose}
              onChange={handleChange}
            />
          </div>

          {/* Employee */}
          <div className="col-md-4">
            <label className="form-label">Employee</label>
            <select
              className="form-select"
              name="employee_id"
              value={form.employee_id}
              onChange={handleChange}
            >
              <option value="">Select Employee</option>
              {employees.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.employee_code} - {emp.first_name}
                </option>
              ))}
            </select>
          </div>

          {/* Save */}
          <div className="col-12 text-end">
            <button
              type="button"
              className="btn add-emp-btn d-flex align-items-center gap-2 py-2 px-3 mt-4"
              onClick={saveOutdoorEntry}
              disabled={saving}
            >
              {saving ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="mt-4">
        <h4 className="mb-3">Outdoor Entries List</h4>

        {loading ? (
          <div className="text-center py-3">Loading...</div>
        ) : (
          <div className="table-responsive settings-table mt-3">
            <table className="table table-hover m-0">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th>From Time</th>
                  <th>To Time</th>
                  <th>Location</th>
                  <th>Purpose</th>
                  <th>Employee</th>
                </tr>
              </thead>
              <tbody>
                {list.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No entries
                    </td>
                  </tr>
                ) : (
                  list.map((item, index) => (
                    <tr key={item.id || index}>
                      <td>{index + 1}</td>
                      <td>{item.from_date}</td>
                      <td>{item.to_date}</td>
                      <td>{timeFormat(item.from_time)}</td>
                      <td>{timeFormat(item.to_time)}</td>
                      <td>{item.location}</td>
                      <td>{item.purpose}</td>
                      <td>
                        {item.employee?.first_name +
                          " " +
                          item.employee?.last_name || "-"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
